var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392 135.995c-33.74 0-64.22 13.92-86.02 36.33l-29.06 29.87 31.42 32.29 29.92-30.76c13.63-14.01 32.69-22.73 53.74-22.73 41.35 0 75 33.65 75 75.01 0 41.35-33.65 75-75 75-21.05 0-40.11-8.72-53.74-22.74-117.536-120.824-132.066-135.761-132.24-135.94-21.8-22.41-52.28-36.33-86.02-36.33-66.27 0-120 53.73-120 120.01 0 66.27 53.73 120 120 120 33.74 0 64.22-13.92 86.02-36.33l29.06-29.87-31.42-32.29-29.92 30.75c-13.63 14.02-32.69 22.74-53.74 22.74-41.35 0-75-33.65-75-75 0-41.36 33.65-75.01 75-75.01 21.05 0 40.11 8.72 53.74 22.73 5.151 5.296 131.004 134.68 132.24 135.95 21.8 22.41 52.28 36.33 86.02 36.33 66.27 0 120-53.73 120-120 0-66.28-53.73-120.01-120-120.01z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/All.ba5e3c13.svg";
export { ForwardRef as ReactComponent };